// extracted by mini-css-extract-plugin
module.exports = {"inputInfo":"Inputbox_inputInfo__2N6TM","inputBox":"Inputbox_inputBox__rm8to"};